import { PatientFile } from './file';
import {
  AlignerTreatmentPlanUpperOrLowerType,
  TaskBlockReason,
  TreatmentPlanTask,
  TreatmentPlanType,
} from './treatmentPlan';

export type PatientCase = {
  treatmentNote: string | undefined;
  alignerTreatmentPlanUpperOrLowerType: AlignerTreatmentPlanUpperOrLowerType;
  id: number;
  createdBy: string;
  createdAt: string;
  updatedBy: string;
  updateAt: string;
  clinicId: string;
  task: TreatmentPlanTask;
  taskStatusUpdatedAt: string;
  assignedDoctorId?: string;
  treatmentPlan: string;
  treatmentPlanType: TreatmentPlanType;
  diagnosis: string;
  diagnosisUpdatedBy: string;
  patientComplaint: string;
  scan3dLinks: string[];
  letterLinks: string[];
  otherLinks: string[];
  externalPatientId: number;
  firstName: string;
  lastName: string;
  oralHealthTherapist: string;
  isArchived: boolean;
  isTaskBlocked: boolean;
  taskBlockReason: TaskBlockReason;
  taskBlockComment: string | null;
  files: PatientFile[];
  submittedAt: string;
  dateOfBirth: string;
};

export type Patient = {
  id: number;
  clinicId: string;
  task: TreatmentPlanTask;
  taskStatusUpdatedAt: string;
  assignedDoctorId: string;
  externalPatientId: number;
  firstName: string;
  lastName: string;
  oralHealthTherapist: string;
  isTaskBlocked: boolean;
  isUnreadMessageExists: boolean;
  dateOfBirth: string;
};

export type PatientListInfoResponse = {
  totalPages: number;
  totalElements: number;
  size: number;
  content: Patient[];
  number: number;
  sort: {
    empty: boolean;
    sorted: boolean;
    unsorted: boolean;
  };
  numberOfElements: number;
  pageable: {
    offset: number;
    sort: {
      empty: boolean;
      sorted: boolean;
      unsorted: boolean;
    };
    pageNumber: number;
    pageSize: number;
    paged: boolean;
    unpaged: boolean;
  };
  first: boolean;
  last: boolean;
  empty: boolean;
};

export type PatientListInfo = Omit<PatientListInfoResponse, 'content'>;

export enum PatientSort {
  lastName = 'lastName,asc',
  idAsc = 'externalPatientId,asc',
  idDesc = 'externalPatientId,desc',
}

export type GetPatientCasesParams = {
  search?: string;
  treatmentPlanTypes?: TreatmentPlanType[];
  clinicIds?: string[];
  doctorIds?: string[];
  tasks?: TreatmentPlanTask[];
  notTasks?: TreatmentPlanTask[];
  isArchived?: boolean;
  isTaskBlocked?: boolean;
  showWithoutAssignedDoctor?: boolean;
  page?: number;
  size?: number;
  sort?: PatientSort;
  isOnlyWithMessagesForCurrentUser?: boolean;
  onlyWithMessagesOrTasks?: TreatmentPlanTask[];
  isExcludeDismissed?: boolean;
};

export type GetPatientCasesCount = {
  count: number;
};

export enum PatientCaseErrorMessages {
  assignedToAnotherDoctor = 'PATIENT_CASE_ASSIGNED_TO_ANOTHER_DOCTOR',
  assignedDoctorWasChanged = 'PATIENT_CASE_ASSIGNED_DOCTOR_WAS_CHANGED',
  notAssignedToAnyDoctor = 'PATIENT_CASE_NOT_ASSIGNED_TO_ANY_DOCTOR',
}
